import { render, staticRenderFns } from "./goodsSalesStatistic.vue?vue&type=template&id=1a65aa0e&scoped=true"
import script from "./goodsSalesStatistic.vue?vue&type=script&lang=js"
export * from "./goodsSalesStatistic.vue?vue&type=script&lang=js"
import style0 from "./goodsSalesStatistic.vue?vue&type=style&index=0&id=1a65aa0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a65aa0e",
  null
  
)

export default component.exports